import QRCodeRoute from "@/features/qr-code/components/QrCodeRoute";
import { services as s } from "@/services";
import type { TemplateSettingsSchemaT } from "@/types";
import type { TemplateT } from "@/types/database/quickstarts";
import { useRouter } from "@tanstack/react-router";

type Template = TemplateT & {
  templates_access: {
    access: "viewer" | "editor";
  }[];
};

const quickstartId = s.uuidv4();

function TemplateQRCode(
  { template }: {
    template: Template;
  },
) {
  return (
    <QRCodeRoute
      route={{
        to: "/signup",
        search: {
          ...(template.settings as TemplateSettingsSchemaT),
          role: "PATIENT",
          organisation: {
            organisation_id: template.settings.organisation_id,
          },
          quickstart_key: template?.quickstart_key?.toUpperCase() ??
            "INJECTION",
          quickstart_id: quickstartId,
        },
      }}
      title={template.settings.name}
    />
  );
}

export default TemplateQRCode;
